/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { CardAuction, CardAuctionInterface } from "../CardAuction";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "contractRegistry",
        type: "address",
      },
      {
        internalType: "uint24",
        name: "minAuctionDuration",
        type: "uint24",
      },
      {
        internalType: "uint24",
        name: "maxAuctionDuration",
        type: "uint24",
      },
      {
        internalType: "uint24",
        name: "bidExtensionDuration",
        type: "uint24",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "lsp8Contract",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "CardAuctionActiveAuction",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bidAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minimumBid",
        type: "uint256",
      },
    ],
    name: "CardAuctionBidTooSmall",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
      {
        internalType: "address",
        name: "seller",
        type: "address",
      },
    ],
    name: "CardAuctionCannotCancelAuctionWhenNotSeller",
    type: "error",
  },
  {
    inputs: [],
    name: "CardAuctionCannotCancelAuctionWithActiveBid",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "CardAuctionCannotFinalizeWithoutActiveBid",
    type: "error",
  },
  {
    inputs: [],
    name: "CardAuctionHasEnded",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint24",
        name: "value",
        type: "uint24",
      },
      {
        internalType: "uint256",
        name: "minValue",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxValue",
        type: "uint256",
      },
    ],
    name: "CardAuctionInvalidAuctionSetting",
    type: "error",
  },
  {
    inputs: [],
    name: "CardAuctionInvalidDuration",
    type: "error",
  },
  {
    inputs: [],
    name: "CardAuctionInvalidMinimumBid",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "lsp8Contract",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "CardAuctionNoActiveAuction",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "CardAuctionTokenNotWhitelisted",
    type: "error",
  },
  {
    inputs: [],
    name: "ContractRegistryRequired",
    type: "error",
  },
  {
    inputs: [],
    name: "RevenueShareCallbackInvalidSender",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "lsp8Contract",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "bidder",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bidAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
    ],
    name: "AuctionBid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "lsp8Contract",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "AuctionCancel",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "lsp8Contract",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "auctionWinner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bidAmount",
        type: "uint256",
      },
    ],
    name: "AuctionFinalize",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "lsp8Contract",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "acceptedToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minimumBid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
    ],
    name: "AuctionOpen",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "lsp8Contract",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "auctionFor",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "seller",
            type: "address",
          },
          {
            internalType: "address",
            name: "acceptedToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "minimumBid",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endTime",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "activeBidder",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "activeBidAmount",
            type: "uint256",
          },
        ],
        internalType: "struct ICardAuction.CardAuctionState",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "auctionSettings",
    outputs: [
      {
        components: [
          {
            internalType: "uint24",
            name: "minAuctionDuration",
            type: "uint24",
          },
          {
            internalType: "uint24",
            name: "maxAuctionDuration",
            type: "uint24",
          },
          {
            internalType: "uint24",
            name: "bidExtensionDuration",
            type: "uint24",
          },
        ],
        internalType: "struct ICardAuction.AuctionSettings",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "lsp8Contract",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "cancelAuctionFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "claimToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "claimableAmountsFor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractRegistry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "lsp8Contract",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
    ],
    name: "finalizeAuctionFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getAllAuctions",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "lsp8Contract",
            type: "address",
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "tokenId",
                type: "bytes32",
              },
              {
                components: [
                  {
                    internalType: "address",
                    name: "seller",
                    type: "address",
                  },
                  {
                    internalType: "address",
                    name: "acceptedToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "minimumBid",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "endTime",
                    type: "uint256",
                  },
                  {
                    internalType: "address",
                    name: "activeBidder",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "activeBidAmount",
                    type: "uint256",
                  },
                ],
                internalType: "struct ICardAuction.CardAuctionState",
                name: "auction",
                type: "tuple",
              },
            ],
            internalType: "struct ICardAuction.AuctionForTokenId[]",
            name: "auctions",
            type: "tuple[]",
          },
        ],
        internalType: "struct ICardAuction.AuctionsForLSP8Contract[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "lsp8Contract",
        type: "address",
      },
    ],
    name: "getAuctionsForLSP8Contract",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "lsp8Contract",
            type: "address",
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "tokenId",
                type: "bytes32",
              },
              {
                components: [
                  {
                    internalType: "address",
                    name: "seller",
                    type: "address",
                  },
                  {
                    internalType: "address",
                    name: "acceptedToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "minimumBid",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "endTime",
                    type: "uint256",
                  },
                  {
                    internalType: "address",
                    name: "activeBidder",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "activeBidAmount",
                    type: "uint256",
                  },
                ],
                internalType: "struct ICardAuction.CardAuctionState",
                name: "auction",
                type: "tuple",
              },
            ],
            internalType: "struct ICardAuction.AuctionForTokenId[]",
            name: "auctions",
            type: "tuple[]",
          },
        ],
        internalType: "struct ICardAuction.AuctionsForLSP8Contract",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "lsp8Contract",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "acceptedToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minimumBid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
    ],
    name: "openAuctionFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "totalFee",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "dataForCallback",
        type: "bytes",
      },
    ],
    name: "revenueShareCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint24",
        name: "minAuctionDuration",
        type: "uint24",
      },
      {
        internalType: "uint24",
        name: "maxAuctionDuration",
        type: "uint24",
      },
      {
        internalType: "uint24",
        name: "bidExtensionDuration",
        type: "uint24",
      },
    ],
    name: "setAuctionSettings",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "lsp8Contract",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "tokenId",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "bidAmount",
        type: "uint256",
      },
    ],
    name: "submitBid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class CardAuction__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    contractRegistry: string,
    minAuctionDuration: BigNumberish,
    maxAuctionDuration: BigNumberish,
    bidExtensionDuration: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CardAuction> {
    return super.deploy(
      contractRegistry,
      minAuctionDuration,
      maxAuctionDuration,
      bidExtensionDuration,
      overrides || {}
    ) as Promise<CardAuction>;
  }
  getDeployTransaction(
    contractRegistry: string,
    minAuctionDuration: BigNumberish,
    maxAuctionDuration: BigNumberish,
    bidExtensionDuration: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      contractRegistry,
      minAuctionDuration,
      maxAuctionDuration,
      bidExtensionDuration,
      overrides || {}
    );
  }
  attach(address: string): CardAuction {
    return super.attach(address) as CardAuction;
  }
  connect(signer: Signer): CardAuction__factory {
    return super.connect(signer) as CardAuction__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CardAuctionInterface {
    return new utils.Interface(_abi) as CardAuctionInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CardAuction {
    return new Contract(address, _abi, signerOrProvider) as CardAuction;
  }
}
